var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-container" }, [
    _c(
      "table",
      {
        staticClass: "tabela-retornos tabela-retornos-mensais table-new-ux-v1"
      },
      [
        _c("thead", [
          _c(
            "tr",
            [
              _c("th", { staticClass: "no-border border-bottom-thead" }),
              _vm._l(_vm.headersMonthlyReturn, function(mes) {
                return _c(
                  "th",
                  {
                    key: mes,
                    staticClass:
                      "text-left text-dark no-border border-bottom-thead"
                  },
                  [_c("strong", [_vm._v(_vm._s(mes))])]
                )
              }),
              _vm._m(0)
            ],
            2
          )
        ]),
        _c(
          "tbody",
          { staticClass: "double-items" },
          [
            _vm._l(_vm.linhasRetorno, function(v, i) {
              return [
                _c(
                  "tr",
                  { key: "retorno-l1-" + i },
                  [
                    _c("td", { staticClass: "text-left no-wrap" }, [
                      _c("strong", [_vm._v(_vm._s(v[0]))])
                    ]),
                    _vm._l(_vm.headersMonthlyReturn, function(value) {
                      return _c(
                        "td",
                        { key: "l1-" + value, staticClass: "text-left" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(v[1][value] ? v[1][value].rent : "-") +
                              " "
                          )
                        ]
                      )
                    }),
                    _c("td", { staticClass: "text-left" }, [
                      _c("strong", [_vm._v(_vm._s(v[1].rent || "-"))])
                    ])
                  ],
                  2
                ),
                _c(
                  "tr",
                  { key: "retorno-l2-" + i },
                  [
                    _c("td", { staticClass: "text-left no-wrap" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.relativeRowLabel))])
                    ]),
                    _vm._l(_vm.headersMonthlyReturn, function(value) {
                      return _c(
                        "td",
                        { key: "l2-" + value, staticClass: "text-left" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                v[1][value] ? v[1][value].rent_relativa : "-"
                              ) +
                              " "
                          )
                        ]
                      )
                    }),
                    _c("td", { staticClass: "text-left" }, [
                      _c("strong", [_vm._v(_vm._s(v[1].rent_relativa || "-"))])
                    ])
                  ],
                  2
                )
              ]
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      { staticClass: "text-dark text-left no-border border-bottom-thead" },
      [_c("strong", [_vm._v("Ano")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }